import { ContentType } from 'types/publishedAssets';
import { useGetContentTranslations } from 'utils/useGetContentTranslations';
import { useTranslation } from 'react-i18next';
import { Icon, IconName } from 'components/Atoms/Icon/Icon';
import { SecondaryText } from 'components/Content/Atoms/SecondaryText';
import styles from './ContactUs.module.scss';

interface Props {
  content: ContentType;
}

export function ContactUs(props: Props) {
  const { content } = props;
  const { translate } = useGetContentTranslations();
  const { t } = useTranslation();
  const title = translate(content.translations, 'title');
  const socialTagline = translate(content.translations, 'social_tagline');
  const secondaryText = translate(content.translations, 'description');
  const phoneNumber = content?.metadata?.phone_number;
  const email = content?.metadata?.email;
  const showSocialTagline = socialTagline && content.components.length > 0;
  return (
    <div className={styles.containerOuter}>
      <div className={styles.containerInner}>
        <div className={styles.contactBlock}>
          <div className={styles.headingGroup}>
            <h3 className={styles.title}>{title}</h3>
            <SecondaryText text={secondaryText} flush />
          </div>
          {phoneNumber && (
            <div>
              {t('contactUs.call')} {phoneNumber}
            </div>
          )}
          {email && (
            <div>
              {t('contactUs.email')}{' '}
              <a href={`mailto:${email}`} className={styles.email} target="_blank" rel="noopener noreferrer">
                {email?.split('?')?.[0]}
              </a>
            </div>
          )}
        </div>
        <div className={styles.followBlockOuter}>
          <div className={styles.followBlockInner}>
            {showSocialTagline && socialTagline}
            {content.components.map((component) => (
              <a
                key={component.id}
                href={component?.metadata?.contact_value}
                target="_blank"
                rel="noopener noreferrer"
                className={styles.followLink}
                aria-label={component?.metadata?.icon_name}
              >
                {component.content_component_type === 'contact_method' && (
                  <Icon name={component?.metadata?.icon_name as IconName} />
                )}
              </a>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
